export const authNavigation = {
  assign(url: string) {
    window.location.assign(url);
  },
};
